var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamionRecogida2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #343434;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M438.4,214.1l-87.7-125.9c-20-28.6-52.6-45.6-87.5-45.6h-7.1c-35.3,0-64,28.7-64,64v106.7h-106.7C38.2,213.3,0,251.5,0,298.7v42.7c0,23.6,19.1,42.7,42.7,42.7v10.7c0,41.2,33.4,74.7,74.7,74.7s74.7-33.4,74.7-74.7v-10.7h128v10.7c0,41.2,33.4,74.7,74.7,74.7s74.7-33.4,74.7-74.7v-10.7c23.6,0,42.7-19.1,42.7-42.7v-42.7c0-42.6-31.4-78.7-73.6-84.5ZM234.7,106.7c0-11.8,9.6-21.3,21.3-21.3h7.1c21,0,40.6,10.2,52.6,27.4l70.1,100.6h-151.1v-106.7ZM149.3,394.7c0,17.7-14.3,32-32,32s-32-14.3-32-32v-10.7h64v10.7ZM426.7,394.7c0,17.7-14.3,32-32,32s-32-14.3-32-32v-10.7h64v10.7ZM469.3,341.3H42.7v-42.7c0-23.6,19.1-42.7,42.7-42.7h341.3c23.6,0,42.7,19.1,42.7,42.7v42.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamionRecogida2);
export default __webpack_public_path__ + "static/media/camion-recogida-2.310847e44fd99d457839688fead48b5b.svg";
export { ForwardRef as ReactComponent };